import { getReduxSelector } from '@gymaholic/packages'
import { WORKOUTS_PATH } from 'modules/workout/redux/constants/index.js'

const getTagWorkoutsSelect = state => getReduxSelector(WORKOUTS_PATH.TAG)(state)

export default getTagWorkoutsSelect
